import "./ArticleGroup.scss";
import React from "react";
import { Box } from "@mui/material";
import { ArticleGroupData } from "../../models/app-data-model";
import ArticleCard from "../article-card/ArticleCard";
import { mockArticleGroupData } from "../../../mocks/app-data-mocks";

export type ArticleGroupProps = {
  articleGroupData: ArticleGroupData;
};

const ArticleGroup: React.FC<ArticleGroupProps> = ({ articleGroupData }) => {
  const { variant, article_cards } = articleGroupData;

  const articleGroup = article_cards.length > 0
    ? article_cards.map((card, index) => (
        <ArticleCard articleCardData={card} variant={variant} key={index} />
      ))
    : null;

  return (
    <Box className='article-group'>
      {articleGroup}
    </Box>
  );
};

export default ArticleGroup;